import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
import { isRequired } from "../../Util/Util/validations.js";
const Street = ({
  label,
  errorMessage,
  validations = [isRequired],
  ...rest
}) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "streetName",
    "data-t": "street",
    label,
    errorMessage,
    validations,
    ...rest
  }
);
export {
  Street as default
};
//# sourceMappingURL=Street.js.map
